import { HttpErrorResponse, HttpEvent, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { RefreshAccessTokenService } from '@modules/authentication/services/refresh-access-token.service';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
  const interceptorTokenRefreshService = inject(RefreshAccessTokenService);

  const excludedUrls = ['/status', '/user/current'];
  const isExcluded = excludedUrls.some((url) => req.url.includes(url));
  if (isExcluded) {
    return next(req) as Observable<HttpEvent<unknown>>;
  }

  const clonedReq = req.clone();

  return next(clonedReq).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized) {
        return interceptorTokenRefreshService.attemptRefresh(clonedReq, next);
      }
      return throwError(() => error) as Observable<HttpEvent<unknown>>;
    }),
  ) as Observable<HttpEvent<unknown>>;
};
